import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=d4edb4a0&scoped=true&"
import script from "./HomeCarousel.vue?vue&type=script&lang=js&"
export * from "./HomeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomeCarousel.vue?vue&type=style&index=0&id=d4edb4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4edb4a0",
  null
  
)

export default component.exports